import { Component } from '@angular/core'

@Component({
    selector: 'app-test',
    imports: [],
    templateUrl: './test.component.html',
    styleUrl: './test.component.scss',
})
export class TestComponent {

}
